import { DependencyList, useEffect, useRef, useState } from 'react'

interface IOptions {
  once?: boolean
}

export function useHover<Surface extends Element>(
  ref = useRef<Surface>(null),
  options?: IOptions,
  deps?: DependencyList,
) {
  const { once } = Object.assign({ once: false }, options)
  const [mouseOver, setMouseOver] = useState(false)

  const handleMouseOver = () => {
    setMouseOver(true)
  }

  const handleMouseOut = () => {
    setMouseOver(false)
  }

  useEffect(() => {
    const node = ref.current
    if (node) {
      node.addEventListener('mouseenter', handleMouseOver, { once })
      node.addEventListener('mouseleave', handleMouseOut, { once })

      return () => {
        node.removeEventListener('mouseenter', handleMouseOver)
        node.removeEventListener('mouseleave', handleMouseOut)
      }
    }
  }, [ref.current, once, ...(deps || [])])

  return { ref, mouseOver }
}
